import { KeyboardArrowRight } from '@mui/icons-material'
import { Chip, Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { HighlightedText } from '@omnea-app/fe-legacy/components/shared/ui/HighlightedText/HighlightedText'
import { IndexRange } from '@omnea-app/fe-legacy/utils/string/fuzzySearchList'
import { InitialsAvatar } from '@omnea-app/fe-users-and-groups/avatar/InitialsAvatar'
import { AvailableOrganisation } from '@omnea-app/login/loginFrontendClient'
import { Nullish } from '@omnea-app/packages/universal/utility-types/utilityTypes'
import { useOrgRoleLabel } from '../../useOrgRoleLabel'
import { OrganisationMenuItemButtonWrapper } from './OrganisationMenuItemButtonWrapper'

interface OrganisationMenuItemProps {
  organisation: AvailableOrganisation
  highlightedRanges: Nullish<IndexRange[]>
  handlePickOrganisation: (organisationId: string) => void
  isFirst: boolean
  isQaOrg: boolean
}

export const OrganisationMenuItem: React.FC<OrganisationMenuItemProps> = ({
  organisation,
  highlightedRanges,
  handlePickOrganisation,
  isFirst,
  isQaOrg,
}) => {
  const roleLabel = useOrgRoleLabel()

  const isFirstSearchResult = isFirst && !!highlightedRanges

  return (
    <OrganisationMenuItemButtonWrapper
      onClick={() => handlePickOrganisation(organisation.id)}
      data-is-first-search-result={isFirstSearchResult}
    >
      <Stack direction="row" gap={1} alignItems="center">
        {organisation.iconUrl ? (
          <picture>
            <img src={organisation.iconUrl} alt={organisation.name} height={20} width={20} />
          </picture>
        ) : (
          <InitialsAvatar
            fullName={organisation.name[0] || '!'}
            size={20}
            sx={{ backgroundColor: 'bg.neutral.muted', color: 'fg.subtle' }}
            variant="square"
          />
        )}
        <Typography variant="body-medium" flexGrow={1} textAlign="left" margin={0} noWrap>
          <HighlightedText text={organisation.name} highlightedRanges={highlightedRanges} />
        </Typography>
        {isQaOrg && <Image src="/app/assets/qa-chip.svg" alt="qa chip" height={18} width={26} />}
      </Stack>
      <Stack direction="row" alignItems="center" gap={2}>
        <Chip label={roleLabel(organisation)} color={organisation.user.role === 'supplier' ? 'neutral' : 'info'} size="tiny" />
        <KeyboardArrowRight
          sx={{
            width: 18,
            height: 18,
            color: 'fg.muted',
          }}
        />
      </Stack>
    </OrganisationMenuItemButtonWrapper>
  )
}
